@if (contentlet()) {
<!--  image with textAlign -->
<ng-template #imageWithTextAlign>
  <a [routerLink]="contentlet().link" [attr.title]="contentlet().title">
    @if (buildImageSrc() | async | dotCmsCodecEncode; as imageSrc) {
    <div
      [id]="'image-container-' + contentlet().identifier"
      [ngClass]="contentlet().cssClass"
      [ngStyle]="{ 'text-align': contentlet().textAlign }"
    >
      <dot-cms-animation [animation]="getFieldAnimation(contentlet().animations, 'fileAsset')">
        <img
          [id]="'image-' + contentlet().identifier"
          loading="lazy"
          [src]="imageSrc"
          [alt]="contentlet().title"
          [title]="contentlet().title"
        />
      </dot-cms-animation>
    </div>
    }
  </a>
</ng-template>
<!--Dotcms-image -->
<!--        (click)="selectPromotionGTMEvent()" -->
<ng-template #defaultImage>
  <div class="default-image-class">
    <div class="dot-cms-image-wrapper">
      <a [attr.title]="contentlet().linkTitle || contentlet().title" class="teaser-link">
        @if (buildImageSrc() | async | dotCmsCodecEncode; as imageSrc) {
        <div [id]="'image-container-' + contentlet().identifier" [ngClass]="contentlet().cssClass">
          <dot-cms-animation [animation]="getFieldAnimation(contentlet().animations, 'fileAsset')">
            <img [id]="'image-' + contentlet().identifier" loading="lazy" [src]="imageSrc" [alt]="contentlet().title" />
          </dot-cms-animation>
        </div>
        }
      </a>
    </div>
  </div>
</ng-template>
<ng-container *ngTemplateOutlet="contentlet()?.textAlign ? imageWithTextAlign : defaultImage" />
} @if(content()){ @if (buildImageSrc() | async | dotCmsCodecEncode; as imageSrc) {
<img [alt]="attrs()?.['alt']" [src]="$srcURL()" />
} }
